import { render, staticRenderFns } from "./SelectParasite.vue?vue&type=template&id=4c0a5358&scoped=true"
import script from "./SelectParasite.vue?vue&type=script&lang=js"
export * from "./SelectParasite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0a5358",
  null
  
)

export default component.exports